module.exports = __webpack_public_path__ + "img/max-delsid-8-Aght_oHog-unsplash.ff4d9adb.jpg";